import { CPRS_STATE_APPLICATION_QUERY } from "@/graphql/cprs-state-to-state-application-query";
import { Component, Vue } from "vue-property-decorator";
import { gql } from "graphql-tag";
import CheckboxButtonComponent from "../checkbox-button/checkbox-button.component.vue";
import FileUploadComponent from "../file-upload/file-upload.component.vue";
import InputOtherComponent from "../input-other/input-other.component.vue";
import RadioButtonComponent from "../radio-button/radio-button.component.vue";
import SignatureSubmissionComponent from "../signature-submission/signature-submission.component.vue";
import {
  CprsStateApplication,
  FormFieldContents,
  FormNavbar,
} from "@/models/cprs-state-to-state-application/cprs-state-to-state-application.interface";
import StateToStatePreviewFormComponent from "../cprs-state-to-state-preview-form/cprs-state-to-state-preview.component.vue";
import { utils } from "@/utils/utils";
import moment from "moment";
import DropdownListComponent from "../dropdown-list/dropdown-list.component.vue";
import { loginApi } from "@/providers/apis/login";
import { stateToStateFormApi } from "@/providers/apis/state-to-state-form";
import AppLoaderComponent from "../app-loader/app-loader.component.vue";
import { appConfigService } from "@/providers/services/app/app-config";
import ErrorPopupComponent from "../error-popup/error-popup.component.vue";
import FormInputDatepickerComponent from "../form-input-datepicker/form-input-datepicker.component.vue";
import EligibilityPopupComponent from "../eligibility-qsn-valid-popup/eligibility-qsn-valid-popup.vue";

@Component({
  name: "cprs-state-to-state-application",
  components: {
    "b-form-radio-group": RadioButtonComponent,
    "b-form-checkbox": CheckboxButtonComponent,
    "b-form-upload-file": FileUploadComponent,
    "b-form-checkbox-input": InputOtherComponent,
    "b-form-signature-submission": SignatureSubmissionComponent,
    "b-state-to-state-preview-form": StateToStatePreviewFormComponent,
    "b-form-dropdown": DropdownListComponent,
    "b-form-input-datepicker": FormInputDatepickerComponent,
    AppLoaderComponent,
    ErrorPopupComponent,
    EligibilityPopupComponent,
  },
})
export default class CprsStateToStateApplicationComponent extends Vue {
  public isScroll = false;
  public stateApplicationData: Array<CprsStateApplication> = [];
  public applicationNavData: FormNavbar[] = [];
  public formData: FormFieldContents[] = [];
  public formPagination = 0;
  public isValid = false;
  public isNavLoad = false;
  public saveDataDraft = false;
  public currentForm: any;
  public formName = "stateToStateBasicDetails";
  public formTitle = {
    main_title: "",
    sub_title: "",
  };
  public stateToStatepayLoadData: any = {
    fillStatus: "DRAFT",
    id: "",
    stateToStateBasicDetails: {
      firstName: "",
      lastName: "",
      otherFirstName: "",
      otherLastName: "",
      gender: "",
      dob: "",
      socialSecurityNumber: "",
      veteranStatus: "",
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      email: "",
      workEmail: null,
    },
    stateToStateCertificationDetails: {
      currentlyCertifiedOtherThanTennessee: "",
      currentState: "",
      certificateFiles: "",
      contactPersonFirstName: "",
      contactPersonLastName: "",
      contactPersonPhone: "",
      contactPersonEmail: "",
      selfDirectedRecovery: "",
      disclosedToPeers: "",
      highSchool: [],
      highSchoolNotListed: "",
    },
    stateToStateSignatureSubmission: {
      isSignature: "",
      submissionDate: moment().format("MM-DD-YYYY"),
    },
  };
  public hideDiv: string[] = ["highSchoolNotListed"];
  public checkField: string[] = ["highSchool"];
  public signatureInvalid = false;
  public eventBind: any = {
    acceptNumberOnly: this.numberValidation,
    avoidNumbersAndSpecialChar: this.avoidNumbersAndSpecialCharacter,
    telCharacter: this.telCharacterValidate,
    onlyAlphabets: this.onlyAlphabets,
  };
  public isEdit = false;
  public checkValidForm = false;
  public formCompletedIndex: number[] = [];
  public mainId = "app";
  public currentRoute = "";
  public isFileValid = false;
  public isErrDobAge = false;
  public eligibilityPopup = false;
  public eligibilityPopupMsg = "";
  public isLoading = true;
  public formApplicationId = "";
  public currentDMY = "";
  public notFilesUploadedKeyNames: string[] = [];
  public errorMessage = "";

  public async created() {
    this.currentRoute = this.$route.path;
    const currentMonth = `${moment().month() + 1}`;
    this.currentDMY = `${moment().year()}-${
      currentMonth.length == 1 ? "0" : ""
    }${currentMonth}-${moment().date()}`;

    loginApi
      .logInWithCredential(
        appConfigService.getClientId(),
        appConfigService.getClientKey(),
        "anonymous"
      )
      .then((data) => {
        this.isLoading = false;
        localStorage.setItem("anonymousToken", data.access_token);
      })
      .catch((error) => {
        this.errorMessage = utils.errorMessage(error);
        this.isLoading = false;
      });
    let payloadStorage: any = localStorage.getItem("stateToStatepayLoadData");
    const formFilledIndex: any = localStorage.getItem(
      "stateToStateFilledIndex"
    );
    if (formFilledIndex) {
      formFilledIndex.split(",").forEach((data: string) => {
        this.formCompletedIndex.push(Number(data));
      });
    }
    // Re-derive step 0 completion from a live validation so a stale mark can't
    // make the finalize gate skip an unfinished Basic Details tab.
    this.syncStepZeroOnLoad();
    if (payloadStorage) {
      payloadStorage = JSON.parse(payloadStorage);
      this.stateToStatepayLoadData = { ...payloadStorage };
    }
    this.$watch(
      () => this.stateToStatepayLoadData.stateToStateBasicDetails.dob,
      (newVal: string) => {
        if (newVal) {
          const dobDate = new Date(newVal);
          const minAgeDate = new Date();
          minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
          this.isErrDobAge = dobDate > minAgeDate;
        } else {
          this.isErrDobAge = false;
        }
      },
      { immediate: true }
    );
    if (this.formPagination === 0) {
      this.isNavLoad = true;
    }
    this.$apollo
      .query({
        query: gql`query ${CPRS_STATE_APPLICATION_QUERY}`,
      })
      .then((result) => {
        this.stateApplicationData =
          result.data.cprsStateToStateApplications.data;
        this.formTitle = {
          main_title: this.stateApplicationData[0].attributes.main_title,
          sub_title: this.stateApplicationData[0].attributes.sub_title,
        };
        this.applicationNavData =
          this.stateApplicationData[0].attributes.state_application_navbar;
        this.formData = this.stateApplicationData[0].attributes.form_fields;
        for (let index = 0; index < this.checkField.length; index++) {
          this.fieldUpdate(this.checkField[index], true);
        }
        // Arm autosave only now: everything above is the form loading itself,
        // not the applicant filling it in.
        this.$nextTick(() => {
          this.startDraftAutoSave();
        });
      });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }
  public mounted() {
    const mainEl: any = document.querySelector(".main-content");
    if (mainEl) {
      mainEl.addEventListener("keyup", (event: any) => {
        if (event.shiftKey && event.keyCode == 9) {
          const el = event.path[0];
          if (el) {
            el.scrollIntoView({ block: "center", behavior: "smooth" });
          }
        }
      });
    }
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("remove-container");
    }
  }

  public saveDraft() {
    this.$bvToast.show("example-toast");
    // Save Draft is a deliberate save, so it reaches the server too - the
    // button says draft saved, and until now it only ever wrote this browser.
    this.persistDraft();
    localStorage.setItem(
      "stateToStatepayLoadData",
      JSON.stringify(this.stateToStatepayLoadData)
    );
    this.saveDataDraft = true;
    setTimeout(() => {
      this.saveDataDraft = false;
    }, 1000);
  }

  public closeToast() {
    this.$bvToast.hide("example-toast");
  }

  public nextButton() {
    this.checkValidForm = true;
    this.isFileValid = !this.isFileValid;
    // Finalizing from the signature step must not skip earlier steps: if any is
    // incomplete (free-nav jumped past it), send the user back to it.
    if (this.formPagination === 2) {
      const incomplete = this.firstIncompleteDataStep();
      if (incomplete !== -1 && incomplete !== 2) {
        this.jumpToIncompleteStep(incomplete);
        return;
      }
    }
    if (this.formPagination === 0) {
      const dob = this.stateToStatepayLoadData.stateToStateBasicDetails.dob;
      if (dob) {
        const dobDate = new Date(dob);
        const minAgeDate = new Date();
        minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
        if (dobDate > minAgeDate) {
          this.eligibilityPopupMsg =
            "You must be at least 18 years old to apply as a Certified Peer Recovery Specialist. If you have additional questions, please reach out to CPRS.TDMHSAS@tn.gov 800-560-5767.";
          this.eligibilityPopup = true;
          setTimeout(() => {
            const el = document.querySelector(".dob-age-error") as HTMLElement;
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }, 100);
          return;
        }
      }
    }
    this.stateToStatepayLoadData.stateToStateBasicDetails.state =
      this.stateToStatepayLoadData.stateToStateBasicDetails.state.toLocaleUpperCase();

    //signature validation
    if (this.formPagination == 2) {
      if (
        this.stateToStatepayLoadData.stateToStateSignatureSubmission.isSignature
      ) {
        this.signatureInvalid = false;
      } else {
        this.checkValidForm = true;
        this.signatureInvalid = true;
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
        return;
      }
    }

    this.$validator.validate().then(async (validate) => {
      if (validate && !this.notFilesUploadedKeyNames.length) {
        // The step completed NOW, before nextPaginationUpdate() advances it.
        const completedStep = this.formPagination;
        if (this.formPagination == 1) {
          if (
            this.stateToStatepayLoadData.stateToStateBasicDetails.email ===
            this.stateToStatepayLoadData.stateToStateCertificationDetails
              .contactPersonEmail
          ) {
            this.errorMessage =
              "Applicant email id and contact person email id must be different *";
            return;
          }
        }
        this.checkValidForm = false;
        this.isLoading = true;
        if (
          this.stateToStatepayLoadData.stateToStateBasicDetails.workEmail === ""
        ) {
          this.stateToStatepayLoadData.stateToStateBasicDetails.workEmail =
            null;
        }
        // An autosave may be pending or in flight. Drop the pending one and wait
        // for the running one, so this updates the row the autosave created
        // instead of racing it and creating a second application.
        if (this.draftAutoSaveTimer) {
          clearTimeout(this.draftAutoSaveTimer);
          this.draftAutoSaveTimer = null;
        }
        await this.draftSave;
        if (!this.stateToStatepayLoadData.id) {
          await stateToStateFormApi
            .StateToStateApplicationForm(
              this.stateToStatepayLoadData.fillStatus,
              this.stateToStatepayLoadData,
              this.currentRoute.split("/")[2]
            )
            .then((result: any) => {
              this.isLoading = false;
              this.formApplicationId = result.headers.location;
              localStorage.setItem(
                "stateToStateApplicationId",
                this.formApplicationId
              );
              this.stateToStatepayLoadData.id = localStorage.getItem(
                "stateToStateApplicationId"
              );
              localStorage.setItem(
                "stateToStatepayLoadData",
                JSON.stringify(this.stateToStatepayLoadData)
              );
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });
        } else {
          const id = this.stateToStatepayLoadData.id;
          if (this.formPagination === 0) {
            await stateToStateFormApi
              .StateToStateApplicationForm(
                this.stateToStatepayLoadData.fillStatus,
                this.stateToStatepayLoadData,
                this.currentRoute.split("/")[2]
              )
              .then()
              .catch((err) => {
                this.formName = "stateToStateBasicDetails";
                this.formPagination = 0;
                this.formCompletedIndex.splice(1, 1);
                localStorage.setItem(
                  "stateToStateFilledIndex",
                  this.formCompletedIndex.toString()
                );
                this.errorMessage = err.response.data.message;
              });
          }
          await stateToStateFormApi
            .updateStateToStateForm(
              this.stateToStatepayLoadData,
              id,
              this.currentRoute.split("/")[2]
            )
            .then((data) => {
              this.isLoading = false;
              if (!this.isEdit) {
                this.nextPaginationUpdate();
              }
              const el = document.getElementById(this.mainId);
              if (el) {
                el.scrollIntoView({ behavior: "smooth" });
              }
            })
            .catch((error) => {
              this.errorMessage = utils.errorMessage(error);
              this.isLoading = false;
            });

          localStorage.setItem(
            "stateToStatepayLoadData",
            JSON.stringify(this.stateToStatepayLoadData)
          );
          if (this.isEdit) {
            this.formPagination = 3;
          }
        }
        if (!this.formCompletedIndex.includes(completedStep)) {
          this.formCompletedIndex.push(completedStep);
        }
        localStorage.setItem(
          "stateToStateFilledIndex",
          this.formCompletedIndex.toString()
        );
        this.currentForm = this.stateToStatepayLoadData[this.formName];
        localStorage.setItem(
          "stateToStatepayLoadData",
          JSON.stringify(this.stateToStatepayLoadData)
        );
      } else {
        setTimeout(() => {
          const el = document.getElementsByClassName("is-invalid")[0];
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "end" });
          }
        }, 10);
      }
    });
  }

  // Validate every data step's mandatory fields before Preview. vee-validate
  // only sees the on-screen step, so we render each step in turn and stop on the
  // first invalid one — landing on that tab and scrolling to the error.
  private dataStepSlugs: string[] = [
    "stateToStateBasicDetails",
    "stateToStateCertificationDetails",
    "stateToStateSignatureSubmission",
  ];

  private firstIncompleteDataStep(): number {
    for (let i = 0; i < this.dataStepSlugs.length; i++) {
      if (!this.formCompletedIndex.includes(i)) {
        return i;
      }
    }
    return -1;
  }

  // Land on an incomplete step and scroll to the first missing required field.
  private jumpToIncompleteStep(index: number) {
    this.isEdit = false;
    this.checkValidForm = true;
    this.notFilesUploadedKeyNames = [];
    this.formName = this.dataStepSlugs[index];
    this.formPagination = index;
    this.isFileValid = !this.isFileValid;
    this.$nextTick(() => {
      this.$validator.validate().then(() => {
        setTimeout(() => {
          const invalid = document.getElementsByClassName("is-invalid")[0];
          if (invalid) {
            invalid.scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
          }
        }, 100);
      });
    });
  }

  private validatorFieldCount(): number {
    try {
      const fields: any = (this.$validator as any).fields;
      return fields && fields.items ? fields.items.length : 0;
    } catch (e) {
      return 0;
    }
  }

  // Mark Basic Details (step 0) complete only when every required field
  // validates; unmark it when a stale/minimal-only mark is left over. Runs only
  // when step 0 is rendered; validated silently.
  private async markStepZeroIfComplete() {
    if (this.formPagination !== 0 || this.validatorFieldCount() === 0) {
      return;
    }
    const valid = await this.$validator.validate();
    this.$validator.errors.clear();
    const idx = this.formCompletedIndex.indexOf(0);
    if (valid && idx === -1) {
      this.formCompletedIndex.push(0);
    } else if (!valid && idx !== -1) {
      this.formCompletedIndex.splice(idx, 1);
    }
    localStorage.setItem(
      "stateToStateFilledIndex",
      this.formCompletedIndex.toString()
    );
  }

  // On load, re-derive step 0 completion once the tab has rendered.
  private async syncStepZeroOnLoad() {
    let tries = 0;
    while (
      tries++ < 30 &&
      (this.formData.length === 0 || this.validatorFieldCount() === 0)
    ) {
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    await this.markStepZeroIfComplete();
  }

  public nextPaginationUpdate() {
    if (this.formPagination < this.formData.length - 1) {
      this.isNavLoad = true;
      const page = this.formPagination + 1;
      if (page == 0) {
        this.formName = "stateToStateBasicDetails";
      } else if (page == 1) {
        this.formName = "stateToStateCertificationDetails";
      } else if (page == 2) {
        this.formName = "stateToStateSignatureSubmission";
      }
      this.formPagination = page;
    }
  }

  public previousButton() {
    this.notFilesUploadedKeyNames = [];
    this.isEdit = false;
    this.checkValidForm = false;
    if (this.formPagination !== 0) {
      const el = document.getElementById(this.mainId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
      this.formPagination = this.formPagination - 1;
      if (this.formPagination == 0) {
        this.formName = "stateToStateBasicDetails";
      } else if (this.formPagination == 1) {
        this.formName = "stateToStateCertificationDetails";
      } else if (this.formPagination == 2) {
        this.formName = "stateToStateSignatureSubmission";
      }
    }
  }

  public onSubmit() {
    this.$validator.validate().then((validate: any) => {
      if (validate) {
        let payloadStorage: any = localStorage.getItem(
          "stateToStatepayLoadData"
        );
        if (payloadStorage) {
          payloadStorage = JSON.parse(payloadStorage);
          this.stateToStatepayLoadData = { ...payloadStorage };
        }
        this.stateToStatepayLoadData.stateToStateBasicDetails.state =
          this.stateToStatepayLoadData.stateToStateBasicDetails.state.toLocaleUpperCase();
        this.isLoading = true;
        this.stopDraftAutoSave();
        this.stateToStatepayLoadData.fillStatus = "COMPLETED";
        if (localStorage.getItem("stateToStateApplicationId")) {
          this.stateToStatepayLoadData.id = localStorage.getItem(
            "stateToStateApplicationId"
          );
        }
        const id = this.stateToStatepayLoadData.id;
        stateToStateFormApi
          .updateStateToStateForm(
            this.stateToStatepayLoadData,
            id,
            this.currentRoute.split("/")[2]
          )
          .then(() => {
            stateToStateFormApi
              .getStateToStateApplicationForm(
                id,
                this.currentRoute.split("/")[2]
              )
              .then((result: any) => {
                localStorage.removeItem("anonymousToken");
                const applicationCode = result.data.code;
                const applicationNameData = {
                  title: "Certified Peer Recovery Specialist Application",
                  SubTitle: "State to state application",
                };
                this.$router.push({
                  path: "/form/submitted",
                  query: {
                    subTitle: applicationNameData.SubTitle,
                    applicationId: applicationCode,
                  },
                });
                this.isLoading = false;
              })
              .catch((error) => {
                this.errorMessage = utils.errorMessage(error);
                this.isLoading = false;
              });

            const el = document.getElementById(this.mainId);
            if (el) {
              el.scrollIntoView({ behavior: "smooth" });
            }
            localStorage.removeItem("stateToStatepayLoadData");
            localStorage.removeItem("stateToStateApplicationId");
            localStorage.removeItem("stateToStateFilledIndex");
          })
          .catch((error) => {
            this.errorMessage = utils.errorMessage(error);
            this.isLoading = false;
          });
      }
    });
  }

  public numberValidation(evt: any, length?: number) {
    utils.onlyNumberKey(evt, length);
  }

  public avoidNumbersAndSpecialCharacter(evt: any) {
    utils.avoidNumbersAndSpecialCharacters(evt);
  }

  public telCharacterValidate(evt: any, length?: number) {
    utils.telCharacterValidate(evt, length);
  }

  public onlyAlphabets(evt: any, fieldName = "") {
    utils.onlyAlphabets(evt, fieldName);
  }

  public fieldValidation(
    value: any,
    eventName: string,
    fieldType: string,
    maxLength = 0,
    fieldName = ""
  ) {
    if (fieldType === "number") {
      this.eventBind[eventName](value, maxLength);
    } else if (fieldName === "state" || fieldName === "currentState") {
      this.eventBind[eventName](value, fieldName);
    } else {
      this.eventBind[eventName](value);
    }
  }

  public emptyEvent() {
    return;
  }

  public allFilesUploaded(event: any) {
    if (this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.splice(event, 1);
    }
  }

  public resetFileKey(event: boolean) {
    if (event) {
      this.notFilesUploadedKeyNames = [];
    }
  }

  public notFileUploaded(event: string) {
    if (!this.notFilesUploadedKeyNames.includes(event)) {
      this.notFilesUploadedKeyNames.push(event);
    }
  }

  public formEdit(slug: any) {
    this.isEdit = true;
    this.formName = slug;
    if (slug == "stateToStateBasicDetails") {
      this.formPagination = 0;
    } else if (slug == "stateToStateCertificationDetails") {
      this.formPagination = 1;
    } else if (slug == "stateToStateSignatureSubmission") {
      this.stateToStatepayLoadData.stateToStateSignatureSubmission.isSignature =
        "";
      localStorage.setItem(
        "stateToStatepayLoadData",
        JSON.stringify(this.stateToStatepayLoadData)
      );
      this.formPagination = 2;
    }
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  public fieldUpdate(groupName = "", initial = false) {
    if (groupName === "dob") {
      const dob = this.stateToStatepayLoadData.stateToStateBasicDetails.dob;
      if (dob) {
        const dobDate = new Date(dob);
        const minAgeDate = new Date();
        minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
        this.isErrDobAge = dobDate > minAgeDate;
      } else {
        this.isErrDobAge = false;
      }
    }
    switch (groupName) {
      case "highSchool":
        if (
          !this.stateToStatepayLoadData.stateToStateCertificationDetails.highSchool.includes(
            "Other"
          )
        ) {
          if (!this.hideDiv.includes("highSchoolNotListed") && !initial) {
            this.hideDiv.push("highSchoolNotListed");
            this.stateToStatepayLoadData.stateToStateCertificationDetails.highSchoolNotListed =
              "";
          } else {
            return;
          }
        } else {
          if (this.hideDiv.indexOf("highSchoolNotListed") >= 0) {
            this.hideDiv.splice(this.hideDiv.indexOf("highSchoolNotListed"), 1);
          }
        }
        break;
      default:
        break;
    }
  }

  public async navigateTab(slug: string, index: number) {
    if (index === this.formPagination) {
      return;
    }
    // Leaving Basic Details: mark it complete only if fully valid. Jumping away
    // from an unfinished tab is allowed — it just does not get marked complete.
    if (this.formPagination === 0) {
      await this.markStepZeroIfComplete();
    }
    // Reaching Preview requires every data step completed (via Next). If any is
    // incomplete, jump to the first one instead.
    if (index === this.dataStepSlugs.length) {
      const incomplete = this.firstIncompleteDataStep();
      if (incomplete !== -1) {
        this.jumpToIncompleteStep(incomplete);
        return;
      }
    }
    this.isEdit = false;
    this.checkValidForm = false;
    this.notFilesUploadedKeyNames = [];
    // Auto-save the current part as a draft before leaving it.
    this.persistDraft();
    this.formName = slug;
    this.formPagination = index;
    const el = document.getElementById(this.mainId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  // Persist the current payload as a draft (fillStatus stays DRAFT) without
  // validation — used when jumping between parts. The row already exists.
  // Draft saves are chained rather than fired in parallel: navigateTab does not
  // await this (the tab switches immediately), so jumping several tabs quickly
  // would otherwise leave overlapping PUTs racing, and the last response to
  // land wins regardless of the order they were sent.
  private draftSave: Promise<void> = Promise.resolve();

  /*
   * The local half on its own. Typing writes here and nowhere else: keystrokes
   * are not an instruction to save, and a request per field is both wasted and
   * a way for a half-typed value to be judged by the API before the applicant
   * has finished it. The server is written on the deliberate actions instead -
   * changing tab, Next, and Save Draft.
   */
  private saveDraftLocally() {
    localStorage.setItem(
      "stateToStatepayLoadData",
      JSON.stringify(this.stateToStatepayLoadData)
    );
  }

  public persistDraft(): Promise<void> {
    this.draftSave = this.draftSave.then(() => this.saveDraftNow());
    return this.draftSave;
  }

  /**
   * Store the draft. The local copy is written unconditionally, so progress
   * survives a reload from the very first field the applicant fills.
   *
   * The server copy needs an email: fetchDetailsfromData() in the workflow API
   * keys the row on it (and rejects the save without a valid one), so the row is
   * created the moment a valid email exists and updated on every save after
   * that. Before then the draft is local-only, which is silent by design — the
   * applicant has not given us anything to file it under yet, so a failed save
   * is not something they can act on.
   */
  private async saveDraftNow() {
    localStorage.setItem(
      "stateToStatepayLoadData",
      JSON.stringify(this.stateToStatepayLoadData)
    );
    const app = this.stateToStatepayLoadData.stateToStateBasicDetails;
    if (!this.stateToStatepayLoadData.id) {
      if (!utils.canSaveDraftRemotely(app.email)) {
        return;
      }
      try {
        const result: any =
          await stateToStateFormApi.StateToStateApplicationForm(
            this.stateToStatepayLoadData.fillStatus,
            this.stateToStatepayLoadData,
            this.currentRoute.split("/")[2]
          );
        this.formApplicationId = result.headers.location;
        localStorage.setItem(
          "stateToStateApplicationId",
          this.formApplicationId
        );
        this.stateToStatepayLoadData.id = this.formApplicationId;
        localStorage.setItem(
          "stateToStatepayLoadData",
          JSON.stringify(this.stateToStatepayLoadData)
        );
      } catch (error) {
        // Kept quiet: an autosave the applicant did not ask for should not throw
        // a popup over the field they are typing in. The local copy above still
        // holds everything, and Next surfaces the real error when they submit.
      }
      return;
    }
    try {
      await stateToStateFormApi.updateStateToStateForm(
        this.stateToStatepayLoadData,
        this.stateToStatepayLoadData.id,
        this.currentRoute.split("/")[2]
      );
    } catch (error) {
      this.errorMessage = utils.errorMessage(error);
    }
  }

  // Debounced autosave, armed once the form has finished loading so the CMS
  // render and the applicant prefill do not count as filling anything in. From
  // the first real keystroke every change is persisted.
  private draftAutoSaveTimer: any = null;

  private queueDraftSave() {
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
    }
    this.draftAutoSaveTimer = setTimeout(() => {
      this.draftAutoSaveTimer = null;
      this.saveDraftLocally();
    }, 1000);
  }

  private draftWatchStop: any = null;

  private startDraftAutoSave() {
    this.draftWatchStop = this.$watch(
      "stateToStatepayLoadData",
      () => {
        // Errors are raised by an action - Next, or the bounce to an
        // incomplete step - and dismissed the moment the applicant starts
        // answering them. Without this the gate stays open after a failed
        // Next and vee-validate re-runs on every keystroke, so typing an
        // email is marked invalid letter by letter until it happens to be
        // complete. They are shown again by the next Next.
        this.checkValidForm = false;
        this.queueDraftSave();
      },
      { deep: true }
    );
  }

  /*
   * Submitting ends the draft. The payload is still mutated on the way out -
   * fillStatus, the signature date, the id read back from storage - and each
   * of those fires the watcher above, queueing a local write. onSubmit then
   * clears the stored draft, and the queued write lands a second later and
   * puts it straight back, so the next application opens on the submitted
   * one's data. Stop the watcher and drop anything pending before the submit
   * runs, so no write can outlive it.
   */
  private stopDraftAutoSave() {
    if (this.draftWatchStop) {
      this.draftWatchStop();
      this.draftWatchStop = null;
    }
    if (this.draftAutoSaveTimer) {
      clearTimeout(this.draftAutoSaveTimer);
      this.draftAutoSaveTimer = null;
    }
  }

  public beforeDestroy() {
    this.stopDraftAutoSave();
  }

  public closdedErrorPopup(event: any) {
    if (event) {
      this.errorMessage = "";
    }
  }

  public closedEligibilityPopup(event: any) {
    this.eligibilityPopup = false;
    if (event) {
      this.$router.push("/user-dashboard/home");
    }
  }

  public classNameChooser(inputClass: string) {
    return utils.classNameChooser(inputClass);
  }
  public goBack() {
    this.$router.push({
      path: `/application`,
      query: {
        form: "state-to-state",
      },
    });
    const el = document.getElementById("header");
    if (el) {
      el.classList.add("active");
      el.classList.remove("remove-container");
    }
  }
}
